<template>
  <Card :disableTitle="true" :height100="false">
    <EmptyState
      image="backups"
      :boldMessage="$t('global.backup-restore-in-progress-desc', { name: site.domain })"
      :subMessage="$t('global.backup-restore-in-progress-warning')"
    />
  </Card>
</template>

<script>
import Card from "@/components/display/Card";
import EmptyState from "@/components/display/empty-state/EmptyState";

export default {
  name: "BackupRestoreNotice",
  components: {
    Card,
    EmptyState,
  },
  props: {
    site: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {};
  },
};
</script>
